'use strict';

(function () {
    'use strict';

    appRun.$inject = ['routerHelper'];
    angular.module('app.open-data').run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
            state: 'open-data',
            config: {
                url: '/open-data',
                component: 'indexOpenData'
            }
        }, {
            state: 'civil-register',
            config: {
                url: '/civil-register',
                component: 'civilRegister'
            }
        }, {
            state: 'municipal-roll',
            config: {
                url: '/municipal-roll',
                component: 'municipalRoll'
            }
        }, {
            state: 'fiscal-data',
            config: {
                url: '/fiscal-data',
                component: 'fiscalData'
            }
        }, {
            state: 'library',
            config: {
                url: '/library',
                component: 'library'
            }
        }, {
            state: 'social-service',
            config: {
                url: '/social-service',
                component: 'socialService'
            }
        }];
    }
})();